module.exports = __webpack_public_path__ + "img/cart-empty-outline-300.7efbf34a.svg";